import React from "react";
import { useRollId } from "../../CommonComponents/RollIdContext";
import "../../CommonComponents/FilterStyles.css";

const Filterbtn = ({ filters, setFilters }) => {
  const { rollId } = useRollId(); // Get rollId from context

  const handleFilterApply = (name, value) => {
    setFilters({ ...filters, [name]: value });
  };


  return (
    <div className="ms-4 mb-4 d-flex ">
      {rollId === "1" && (
        <div className="dropdown me-3">
          <button
            className="btn shadow filter-btn btn-sm btn-outline-secondary dropdown-toggle filter-button"
            type="button"
            id="hgoDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            HGO
          </button>
          <ul className="dropdown-menu" aria-labelledby="hgoDropdown">
            <li>
              <button className="dropdown-item" type="button">
                Name 1
              </button>
            </li>
            <li>
              <button className="dropdown-item" type="button">
                Name 2
              </button>
            </li>
            <li>
              <button className="dropdown-item" type="button">
                Name 3
              </button>
            </li>
          </ul>
        </div>
      )}

      <div className="dropdown me-2">
        <button
          className="btn marginRight filter-btn btn-sm btn-outline-secondary dropdown-toggle filter-button"
          type="button"
          id="dateDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {!!filters.date ? filters.date : "Date"}
        </button>
        <ul className="dropdown-menu" aria-labelledby="dateDropdown">
          <li>
            <input
              type="date"
              value={filters.date}
              onChange={(e) => {
                handleFilterApply("date", e.target.value);
              }}
            />
          </li>
        </ul>
      </div>

      <div className="dropdown me-2">
        <button
          className="btn marginRight filter-btn btn-sm btn-outline-secondary dropdown-toggle filter-button"
          type="button"
          id="timeDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {!!filters.time ? filters.time : "Time"}
        </button>
        <ul className="dropdown-menu" aria-labelledby="timeDropdown">
          <li>
            <input
              type="time"
              value={filters.time}
              onChange={(e) => {
                handleFilterApply("time", e.target.value);
              }}
            />
          </li>
        </ul>
      </div>

      <div className="dropdown me-2">
        <button
          className="btn filter-btn btn-sm btn-outline-secondary dropdown-toggle filter-button"
          type="button"
          id="currencyDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {!!filters.currency ? filters.currency : "Currency"}
        </button>
        <ul className="dropdown-menu" aria-labelledby="currencyDropdown">
          <li>
            <button
              className="dropdown-item"
              type="button"
              onClick={() => {
                handleFilterApply("currency", "PKR");
              }}
            >
              PKR
            </button>
            <button
              className="dropdown-item"
              type="button"
              onClick={() => {
                handleFilterApply("currency", "USD");
              }}
            >
              USD
            </button>
          </li>
        </ul>
      </div>
      <button
        className="clear-filters-btn"
        type="button"
        onClick={() => {
          setFilters({
            date: "",
            time: "",
            currency: "",
          });
        }}
      >
        Clear Filters
      </button>
    </div>
  );
};

export default Filterbtn;
